import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=5551d030&scoped=true"
import script from "./memo.vue?vue&type=script&lang=js"
export * from "./memo.vue?vue&type=script&lang=js"
import style0 from "./memo.vue?vue&type=style&index=0&id=5551d030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551d030",
  null
  
)

export default component.exports